import { EVENT_TYPE, type OpenPageActionConfig } from '@lighthouse/core'
import type { ActionFlowNode, FlowNodeResultADT, OpenPageActionConfigure } from '@lighthouse/shared'
import { commonPages } from '@lighthouse/shared'
import { t } from 'i18next'

import type { ExecuteActionParams } from '../type'

export const handleOpenPageStream = async (
    node: ActionFlowNode<OpenPageActionConfigure>,
    params: ExecuteActionParams
): Promise<undefined | FlowNodeResultADT> => {
    const {
        data: { config }
    } = node

    if (!config || !config.openPageId) {
        throw new Error(t('configurationNotPerfect'))
    }

    const success = handleOpenPage(config, params)

    if (!success) {
        throw new Error(t('openPageError'))
    }

    return await Promise.resolve({
        type: 'record',
        success
    })
}

export const handleOpenPage = (config: OpenPageActionConfig, params: ExecuteActionParams) => {
    const { actionEvents, eventType } = params

    if (!config.openPageId) {
        throw new Error(t('openPageError'))
    }

    if (eventType === EVENT_TYPE.LOAD || eventType === EVENT_TYPE.LOAD_DATA) {
        return true
    }

    if (commonPages.includes(config.openPageId)) {
        actionEvents.openSystemPage(config.openPageId)
        return true
    }

    actionEvents.openPage({ ...config, executeParams: params })

    return true
}
